// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTradingSignalSeenMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADING_SIGNAL_REQ_SEEN_MESSAGE);
        this.TradingSignalId = null;
    }
}
